module.exports = __webpack_public_path__ + "media/budapest/spa-d00270d2.jpg";